// 作业类型 Flag 枚举（与后端接口及 App 端一致）
export const HomeworkFlagEnum = {
  Symbol:     2,   // 音标
  Text:       3,   // 课文（旧版跟读）
  Write:      4,   // 笔试
  Hear:       5,   // 听说题组
  WordNew:    7,   // 新版单词（旧单词模块 moduleContentType=2 也走此值）
  Dub:        8,   // 新配音
  WordPhrase: 9,   // 单词短语（moduleContentType=13）
  TextNewV2:  24,  // 新课文V2（诗词/篇章/对话，moduleContentType=14）
  Written:    100  // 试卷（提交给后端时实际转为 4）
}

// 模块内容类型与作业类型映射 -- 模块内容类型moduleContentType -> 作业类型映射flag
export const flag2moduleContentTypeEnum = {
  1: HomeworkFlagEnum.Symbol,     // '音标' -> 2
  2: HomeworkFlagEnum.WordNew,    // '单词' -> 7
  3: HomeworkFlagEnum.Text,       // '课文' -> 3
  4: 6,                           // '拓展' -> '拓展作业'（6暂未加入HomeworkFlagEnum）
  5: HomeworkFlagEnum.Dub,        // '配音' -> 8
  6: [HomeworkFlagEnum.Write, HomeworkFlagEnum.Hear], // '听说读写' -> '笔试'(4)和'题组'(5)
  // 7:  // 模块类型：'书籍'；作业类型由 groupType 分别决定
  13: HomeworkFlagEnum.WordPhrase, // '新单词' -> 9（直接用，不再经过中间态10）
  14: HomeworkFlagEnum.TextNewV2  // '新课文' -> 24
}
// 模块内容类型与作业类型映射 -- 作业类型映射flag -> 模块内容类型moduleContentType
export const moduleContentType2flagEnum = {
  // 1: , // '单词' ->
  2: 1, // '音标' -> 音标
  3: 3, // '跟读', -> 课文
  4: 6, // '笔试' -> 听说读写
  5: 6, // '题组' -> 听说读写
  6: 4, // '拓展作业' -> 拓展
  7: 2, // '新单词' -> 单词
  8: 5 // '新趣味配音' -> 配音
}

// 各题型练习模式
export const PracticeModeEnum = {
  2: [
    { id: 1, shortName: '朗', name: '朗读单词', remark: '逐个朗读单词，精准纠正发音' },
    { id: 5, shortName: '识', name: '识读音标', remark: '辨识音标对应单词，并进行纠音' },
    { id: 2, shortName: '义', name: '看词选义', remark: '选择所给单词的正确释义' },
    { id: 3, shortName: '词', name: '看义选词', remark: '选择所给释义的正确单词' },
    { id: 6, shortName: '听', name: '听词选义', remark: '选择所听单词的正确释义' },
    { id: 4, shortName: '拼', name: '听音拼写', remark: '听录音，拼写所听到的单词' }
  ],
  3: [
    { id: 2, name: '逐句跟读', remark: '跟随课文示范录音逐句读短文' },
    { id: 1, name: '通篇朗读', remark: '朗读整篇短文的内容' },
    { id: 5, name: '逐句复述', remark: '逐句复述所听到的短文内容' }
  ],
  4: [
    { id: 2, name: '逐句跟读', remark: '跟随课文示范录音逐句读短文' },
    { id: 1, name: '通篇朗读', remark: '朗读整篇短文的内容' },
    { id: 5, name: '逐句复述', remark: '逐句复述所听到的短文内容' }
  ],
  7: [
    { id: 1, shortName: '朗', name: '朗读单词', remark: '逐个朗读单词，精准纠正发音' },
    { id: 5, shortName: '识', name: '识读音标', remark: '辨识音标对应单词，并进行纠音' },
    { id: 2, shortName: '义', name: '看词选义', remark: '选择所给单词的正确释义' },
    { id: 3, shortName: '词', name: '看义选词', remark: '选择所给释义的正确单词' },
    { id: 6, shortName: '听', name: '听词选义', remark: '选择所听单词的正确释义' },
    { id: 4, shortName: '拼', name: '听音拼写', remark: '听录音，拼写所听到的单词' }
  ],
  // 8: [
  //   { id: 1, name: '基础练习', remark: '' },
  //   { id: 2, name: '听力练习', remark: '' },
  //   { id: 3, name: '趣味配音', remark: '' },
  // ],
  13: [
    { id: 1, shortName: '朗', name: '朗读单词', remark: '逐个朗读单词，精准纠正发音' },
    { id: 5, shortName: '识', name: '识读音标', remark: '辨识音标对应单词，并进行纠音' },
    { id: 2, shortName: '义', name: '看词选义', remark: '选择所给单词的正确释义' },
    { id: 3, shortName: '词', name: '看义选词', remark: '选择所给释义的正确单词' },
    { id: 6, shortName: '听', name: '听词选义', remark: '选择所听单词的正确释义' },
    { id: 4, shortName: '拼', name: '听音拼写', remark: '听录音，拼写所听到的单词' }
  ],
  14: [
    { id: 2, name: '逐句跟读', remark: '跟随课文示范录音逐句读短文' },
    { id: 1, name: '通篇朗读', remark: '朗读整篇短文的内容' },
    { id: 5, name: '句子背诵', remark: '逐句背诵课文内容' }
  ]
}
/**
 * 拓展练习指定模块id
 * @type {{ '7': string,'8': string }}
 * 7：初中拓展模块id；8：高中拓展模块id
 */
export const moduleIdByGradeTypeIdeEnum = {
  7: '72B3DBA3A89F436A9FD765114A724DA5',
  8: '607D0C5A8FD44C91834071857F9BD61A'
}
// 趣味配音分类枚举
export const dubTypeEnum = [
  { id: 1, index: 0, pageIndex: 1, key: 'simple', name: '视频片段', moduleContentType: 5, simpleList: [] },
  { id: 2, index: 1, pageIndex: 1, key: 'albumPage', name: '视频专辑', moduleContentType: 5, albumPageList: [] }
]
// 教辅的分类
export const TeachingAssistantEnum = {
  7: [
    // {id: 7, name: '全部'},
    { id: 1, name: '七年级' },
    { id: 2, name: '八年级' },
    { id: 3, name: '九年级' }
  ],
  8: [
    // {id: 8, name: '全部'},
    { id: 4, name: '高一' },
    { id: 5, name: '高二' },
    { id: 6, name: '高三' }
  ]
}

// 年级映射
export const gradeData = {
  '-1': '全部年级',
  0: '六年级',
  1: '七年级',
  2: '八年级',
  3: '九年级',
  4: '高一',
  5: '高二',
  6: '高三',
  7: '初中',
  8: '高中',
  9: '小学',
  100: '幼儿园',
  101: '一年级',
  102: '二年级',
  103: '三年级',
  104: '四年级',
  105: '五年级'
}

// 音素枚举
export const PhonemeContrastEnum = {
  ih: 'ɪ',
  ax: 'ə',
  oo: 'ɒ',
  uh: 'ʊ',
  ah: 'ʌ',
  eh: 'e',
  ae: 'æ',
  iy: 'iː',
  er: 'ɜ:',
  ao: 'ɔ:',
  uw: 'u:',
  'y uw': 'ju:',
  aa: 'ɑ:',
  ey: 'eɪ',
  ay: 'aɪ',
  oy: 'ɔɪ',
  aw: 'aʊ',
  ow: 'əʊ',
  ir: 'ɪə',
  ar: 'eə',
  ur: 'ʊə',
  p: 'p',
  b: 'b',
  t: 't',
  d: 'd',
  k: 'k',
  g: 'g',
  f: 'f',
  v: 'v',
  s: 's',
  th: 'θ',
  dh: 'ð',
  z: 'z',
  sh: 'ʃ',
  zh: 'ʒ',
  ch: 'tʃ',
  jh: 'dʒ',
  hh: 'h',
  m: 'm',
  n: 'n',
  nb: 'nb',
  ng: 'ŋ',
  l: 'l',
  r: 'r',
  y: 'j',
  w: 'w',
  dr: 'dr',
  dz: 'dz',
  tr: 'tr',
  ts: 'ts'
}

// 学段转年级
export const sectionToGradeIdMap = {
  0: 9, // 小学
  1: 7, // 初中
  2: 8 // 高中
}

// 资源文件类型
export const ResourceTypeEnum = {
  student_answer_file: 1210 // 学生作答文件
}

// 模块类型
export const ModuleClassifyEnum = {
  // 普通模块
  Normal: 1,
  // 教辅模块
  Teaching_Aids: 2,
  // 教材模块
  Teaching_Material: 3
}

// 模块内容
export const ModuleContentEnum = {
  // 音标
  Phonetic: 1,
  // 单词
  Word: 2,
  // 课文
  Text: 3,
  // 拓展
  Expand: 4,
  // 配音
  Dub: 5,
  // 听说读写（听说题）
  Listen_Read: 6,
  // 书籍
  Book: 7,
  // 新单词/单题短语
  NewWord: 13,
  // 新课文
  NewText: 14,
  // AI应用
  Ai_App: 20,
  // 听读素材（随身听）
  Walkman: 24,
  // 作文
  Composition: 25
}

// 作业类型
export const HomeworkTypeEnum = {
  Composition: 29
}

/**
 * 1	播放题干
 * 2	播放原文
 * 3	等待时间
 * 4	录音作答
 * 5	播放视频
 * 6	选择题音频
 * 7	课文朗读
 * 8	混合选择题多音频
 * 9	选项勾选
 * 10	播放短文
 * @type {{PLAY_VIDEO: number, PLAY_QUESTION: number, WAIT_TIME: number, PLAY_SHORT_TEXT: number, PLAY_TEXT: number, RECORD_ANSWER: number, READ_TEXT: number, OPTION_SELECT: number, SELECT_AUDIO: number, MIX_SELECT_MULTI_AUDIO: number}}
 */
export const ProcessTypeIdEnum = {
  PLAY_QUESTION: 1, // 播放题干
  PLAY_TEXT: 2, // 播放原文
  WAIT_TIME: 3, // 等待时间
  RECORD_ANSWER: 4, // 录音作答
  PLAY_VIDEO: 5, // 播放视频
  SELECT_AUDIO: 6, // 选择题音频
  READ_TEXT: 7, // 课文朗读
  MIX_SELECT_MULTI_AUDIO: 8, // 混合选择题多音频
  OPTION_SELECT: 9, // 选项勾选
  PLAY_SHORT_TEXT: 10 // 播放短文
}

// 需要作答的流程
export const AnswerProcessTypeIdList = [
  ProcessTypeIdEnum.RECORD_ANSWER,
  ProcessTypeIdEnum.OPTION_SELECT,
  ProcessTypeIdEnum.SELECT_AUDIO,
  ProcessTypeIdEnum.READ_TEXT,
  ProcessTypeIdEnum.MIX_SELECT_MULTI_AUDIO,
  ProcessTypeIdEnum.OPTION_SELECT
]

// 素材类型枚举
export const ProcessMaterialTypeEnum = {
  AUDIO: 1, // 音频
  TEXT: 2, // 文本内容
  VIDEO: 3, // 视频
  IMAGE: 4, // 图片
  QUESTION_STEM: 5, // 题干
  MULTI_AUDIO: 6 // 多音频
}

// 是否满足使用屏显类型的条件：
// 当素材类型(processMaterialType)为文本内容或多音频时，需要再判断屏显类型(showType)
export const isMeetShowType = value =>
  [ProcessMaterialTypeEnum.TEXT, ProcessMaterialTypeEnum.MULTI_AUDIO].includes(value)

// 屏显类型枚举
export const ShowTypeEnum = {
  VIDEO: 0, // 视频
  IMAGE: 1, // 图片
  TEXT: 2, // 文字
  MULTI_AUDIO_CHOOSE: 3, // 多音频选择题
  SINGLE_AUDIO_CHOOSE: 4, // 单音频选择题
  FILL_BLANK: 5, // 填空题,
  CONNECT_WORDS: 12 // 连词
}

// 答案素材类型枚举
export const AnswerMaterialTypeEnum = {
  QUESTION: 1, // 问题
  ANSWER: 2, // 参考答案
  ESSAY: 3, // 参考范文
  ANSWER_POINT: 4 // 答案要点
}

// 答案素材类型映射
export const AnswerMaterialTypeMap = {
  [AnswerMaterialTypeEnum.QUESTION]: '问题',
  [AnswerMaterialTypeEnum.ANSWER]: '参考答案',
  [AnswerMaterialTypeEnum.ESSAY]: '参考范文',
  [AnswerMaterialTypeEnum.ANSWER_POINT]: '叙述要点'
}

// 评测类型枚举
export const AnswerTypeIdEnum = {
  WORDS: {
    label: '单词',
    type: 'WORDS',
    value: 1
  },
  SENTENCE: {
    label: '句子',
    type: 'SENTENCE',
    value: 2
  },
  PARAGRAPH: {
    label: '段落评测',
    type: 'PARAGRAPH',
    value: 3
  },
  ESSAY_QUESTION: {
    label: '问答题',
    type: 'ESSAY_QUESTION',
    value: 5
  },
  TRANSLATE: {
    label: '翻译',
    type: 'TRANSLATE',
    value: 100
  },
  SINGLE_CHOICE: {
    label: '单项选择',
    type: 'SINGLE_CHOICE',
    value: 4
  },
  EXPAND_CHOICE: {
    label: '拓展选择',
    type: 'EXPAND_CHOICE',
    value: 16
  },
  PICTURE_COMPOSITION: {
    label: '看图作文',
    type: 'PICTURE_COMPOSITION',
    value: 6
  },
  STORY_RETELLING: {
    label: '故事复述',
    type: 'STORY_RETELLING',
    value: 15
  }
}

// 评测类型映射
export const AnswerTypeIdMap = {
  1: {
    label: '单词',
    type: 'WORDS',
    value: 1
  },
  2: {
    label: '句子',
    type: 'SENTENCE',
    value: 2
  },
  3: {
    label: '段落评测',
    type: 'PARAGRAPH',
    value: 3
  },
  5: {
    label: '问答题',
    type: 'ESSAY_QUESTION',
    value: 5
  },
  100: {
    label: '翻译',
    type: 'TRANSLATE',
    value: 100
  },
  4: {
    label: '单项选择',
    type: 'SINGLE_CHOICE',
    value: 4
  },
  16: {
    label: '拓展选择',
    type: 'EXPAND_CHOICE',
    value: 16
  },
  6: {
    label: '看图作文',
    type: 'PICTURE_COMPOSITION',
    value: 6
  },
  15: {
    label: '故事复述',
    type: 'STORY_RETELLING',
    value: 15
  }
}

// 作答类型简称映射
export const AnswerTypeTextMap = new Map()
AnswerTypeTextMap.set(
  [AnswerTypeIdEnum.WORDS.value, AnswerTypeIdEnum.SENTENCE.value, AnswerTypeIdEnum.PARAGRAPH.value],
  '朗读'
)
AnswerTypeTextMap.set(
  [
    AnswerTypeIdEnum.SINGLE_CHOICE.value,
    AnswerTypeIdEnum.ESSAY_QUESTION.value,
    AnswerTypeIdEnum.EXPAND_CHOICE.value,
    AnswerTypeIdEnum.TRANSLATE.value
  ],
  '问答'
)
AnswerTypeTextMap.set([AnswerTypeIdEnum.PICTURE_COMPOSITION.value], '作文')
AnswerTypeTextMap.set([AnswerTypeIdEnum.STORY_RETELLING.value], '复述')
// 作答类型简称映射
export const ShowTypeTextMap = new Map()
ShowTypeTextMap.set([ShowTypeEnum.MULTI_AUDIO_CHOOSE, ShowTypeEnum.SINGLE_AUDIO_CHOOSE], '选择')
ShowTypeTextMap.set([ShowTypeEnum.FILL_BLANK], '填空')
ShowTypeTextMap.set([ShowTypeEnum.CONNECT_WORDS], '连词')

/**
 * 媒体文件类型
 * @type {{IMAGE: number, VIDEO: number, AUDIO: number}}
 */
export const MediaFileTypeMap = {
  VIDEO: 1,
  AUDIO: 2,
  IMAGE: 3,
  video: 1,
  audio: 2,
  image: 3
}

/**
 * 生成26位大写字母
 * @returns {string[]}
 */
export function generateCapitalLetter() {
  let i = 64
  return new Array(26).fill(0).map(() => {
    ++i
    return String.fromCharCode(i)
  })
}

export const capitalLetters = generateCapitalLetter()

// 评测类型枚举
export const EvaluateTypeEnum = {
  NOT_EVALUATE: 0, // 不评测
  SENTENCE: 1, // 句子评测
  WORD: 2, // 单词评测
  PARAGRAPH: 3, // 段落评测
  CHAPTER: 4, // 篇章评测
  POETRY: 5, // 诗歌评测
  ALPHABET: 6 // 音标评测
}

export const CoreTypeEnum = {
  WORD: 'en.word.score', // 单词评测
  SENTENCE: 'en.sentence.score', // 句子评测
  ALPHA: 'en.alpha.score', // 音标评测
  PARAGRAPH: 'en.pred.score' // 段落评测
}

// ==================== 课堂任务相关枚举（来源：AI听说课堂/课堂任务管理接口） ====================

// 课堂任务类型（子任务 flag 字段）
export const ClassroomTaskFlagEnum = {
  // 听说题组
  ListenSpeak: 5,
  // 单词短语
  WordPhrase: 9,
  // 新课文
  NewReading: 10
}

export const ClassroomTaskFlagMap = {
  [ClassroomTaskFlagEnum.ListenSpeak]: { label: '听说题组' },
  [ClassroomTaskFlagEnum.WordPhrase]: { label: '单词短语' },
  [ClassroomTaskFlagEnum.NewReading]: { label: '新课文' }
}

// 新课文素材类型（newReadingData.materialType 字段）
export const ReadingMaterialTypeEnum = {
  Poetry: 5, // 诗词
  Dialogue: 6, // 对话
  Article: 7 // 篇章
}

export const ReadingMaterialTypeMap = {
  [ReadingMaterialTypeEnum.Poetry]: { label: '诗词' },
  [ReadingMaterialTypeEnum.Dialogue]: { label: '对话' },
  [ReadingMaterialTypeEnum.Article]: { label: '篇章' }
}

// 课堂任务专用授课模式枚举（按 flag 分组，每项仅含 id 和 name）
export const ClassroomTaskPracticeModeEnum = {
  // key=9：单词短语
  [ClassroomTaskFlagEnum.WordPhrase]: [
    { id: 1, name: '单词朗读' },
    { id: 2, name: '看词选义' },
    { id: 9, name: '听音选词' },
    { id: 6, name: '听词选义' },
    { id: 8, name: '单词PK' },
    { id: 16, name: '单词领读' }
  ],
  // key=10：新课文——按 materialType 分组
  [ClassroomTaskFlagEnum.NewReading]: {
    // materialType=6 对话
    [ReadingMaterialTypeEnum.Dialogue]: [
      { id: 13, name: '句子朗读' },
      { id: 1, name: '单人朗读' },
      { id: 10, name: '角色对话' },
      { id: 14, name: '逐句跟读' },
      { id: 11, name: '逐句背诵' },
      { id: 12, name: '逐句领读' },
      { id: 15, name: '通篇领读' }
    ],
    // materialType=7 篇章
    [ReadingMaterialTypeEnum.Article]: [
      { id: 13, name: '句子朗读' },
      { id: 1, name: '通篇朗读' },
      { id: 10, name: '逐句跟读' },
      { id: 11, name: '逐句背诵' },
      { id: 12, name: '逐句领读' },
      { id: 15, name: '通篇领读' }
    ]
  }
}

// 课堂作答类型（playType 字段）
export const ClassroomPlayTypeEnum = {
  All: 'ALL', // 全班作答
  Single: 'SINGLE', // 单人作答
  Team: 'TEAM' // 集体作答
}

export const ClassroomPlayTypeMap = {
  [ClassroomPlayTypeEnum.All]: { label: '全班作答' },
  [ClassroomPlayTypeEnum.Single]: { label: '单人作答' },
  [ClassroomPlayTypeEnum.Team]: { label: '集体作答' }
}

// 是否使用答题器（answerMachineFlag 字段）
export const AnswerMachineFlagEnum = {
  Yes: 1, // 使用答题器
  No: 2 // 未使用答题器
}

export const AnswerMachineFlagMap = {
  [AnswerMachineFlagEnum.Yes]: { label: '使用答题器' },
  [AnswerMachineFlagEnum.No]: { label: '未使用答题器' }
}

// 单词短语素材类型（wordPhraseData.materialType 字段）
export const WordPhraseMaterialTypeEnum = {
  EnglishWord: 11, // 英语单词
  EnglishPhrase: 12 // 英语短语
}

export const WordPhraseMaterialTypeMap = {
  [WordPhraseMaterialTypeEnum.EnglishWord]: { label: '英语单词' },
  [WordPhraseMaterialTypeEnum.EnglishPhrase]: { label: '英语短语' }
}
